module.exports = __webpack_public_path__ + "static/media/nomster.ee9178ee.png";